export default "__VITE_ASSET__BAkXORVG__"